import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GridComponent, PageSettingsModel, SelectionSettingsModel, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { ActivatedRoute, Router } from '@angular/router';
import { Location, DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { DataManager, WebApiAdaptor, Query} from '@syncfusion/ej2-data';
import { L10n, setCulture } from '@syncfusion/ej2-base';
import { debounceTime, distinctUntilChanged, filter, finalize, switchMap, tap } from 'rxjs/operators';
import { isNumber } from 'highcharts';

import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { SearchProvinciaRequest, SearchComunidadRequest, SearchGremioRequest, SearchEstadoCivilRequest, EmpleadoComunidadHistorialDto, EmpleadoDto, SaveEmpleadoComunidad } from './../../shared/model';
import { SaveEmpleadoDto, Provincia, EstadoCivil } from './../../shared/model';
import { LocalStorageKeys, GridPageSettings, MenuFuncionCodes, TipoDocumento, SearchTipoDocumentoRequest, Gremio, Comunidad, SearchEmpleadoRequestDto, SearchPaisRequest, Pais, DialogPersonaSearchComponentRequestDto, DialogPersonaSearchComponentResponseDto, Persona, DialogConfirmRequest, DialogConfirmResponse, SearchPersonaRequestDto, SavePersonVerificationImageRequestDto, TenantFeatureFlags } from '../../../../src/app/shared/model';
import { EstadoCivilService, GremioService, ComunidadService, ProvinciaService, EmpleadoService, UsuarioService, MenuFuncionService, TipoDocumentoService, PaisService, PersonaService, TenantService } from '../../../../src/app/shared/services';

import { DialogPersonaSearchComponent } from '../usuarios/components/dialogPersonaSearch.component';
import { DialogConfirmComponent } from '../../../../src/app/shared/components/modals/dialogConfirm.component';

setCulture('es-LA');
L10n.load({
  'es-LA': {
    grid: {
        EmptyRecord:"No hay datos para mostrar.",
        Item: 'Item',
        Items: 'Items'   
      },
    pager:{
      currentPageInfo:'{0} de {1} páginas',
      pagerDropDown:'Items por página'
      // totalItemsInfo: ' ({0} elementos)'
    }
  }
});

@Component({
  selector: 'app-empleado-edit',
  templateUrl: './empleado-edit.component.html',
  styleUrls: ['./empleado-edit.component.scss']
})
export class EmpleadoEditComponent implements OnInit {
  formGroup: FormGroup;
  formFileGroup: FormGroup;
  comunidadForm: FormGroup;
  empleadoId: number;
  isProvinciaSearching: boolean = false;

  @ViewChild('fileDescripcion') 
  controlDescripcion: any;
  
  @ViewChild('comunidadGrid')
  public comunidadGrid: GridComponent;
  
  @ViewChild('grid')
  public grid: GridComponent;
  public pageSettings: PageSettingsModel;
  public pageSizes: number[];  
  public selectionOptions: SelectionSettingsModel;
  public toolbarOptions: ToolbarItems[];  
  public dataHistorial: DataManager;
  public query: Query;

  isValidating: boolean = false;
  isSearching: boolean = false;
  isFileAttaching: boolean = false;
  isFileDeleting: boolean = false;
  isUsuariosAsociadosSearching: boolean = false;
  isEmpleadoSaving: boolean = false;
  isTipoDocumentoSearching: boolean = false;
  isEmpleadoSearching: boolean = false;
  isPaisSearching: boolean = false;
  isSubcontratistaSearching: boolean = false;

  cuitOptionSelected: boolean = false;
  isAttachmentSearching: boolean = false;
  isComunidadRolSearching: boolean = false;
  isPersonaDataSearching: boolean = false;
  isImageLoading: boolean = false;
  isDeleting: boolean = false;
  showCuit: boolean = false;
  canEdit: boolean = false;
  canDelete: boolean = false;
  canAdd: boolean = false;
  canView: boolean = false;

  msgError: string = "";
  usuariosAsociadosError: string = "";
  empleado: EmpleadoDto;
  userImageExtension: string = "";
  tipoDocumentoList: TipoDocumento[];
  usuariosAsociadosList: any[];
  empleadoComunidadHistorial : EmpleadoComunidadHistorialDto[];
  descripcion: string = '';
  isDescripcionTouched: boolean = false;
  hayErrorDescripcion: boolean = false;
  canViewPersonDetail: boolean = false;
  personaSearchResult: Persona | null;

  public estadoCivilList: EstadoCivil[];
  isEstadoCivilSearching: boolean = false;

  public comunidadList: Comunidad[];
  isComunidadSearching: boolean = false;

  public SubcontratistaList: EmpleadoDto[];
  isSubContratistaSearching: boolean = false;

  public gremioList: Gremio[];
  isGremioSearching: boolean = false;

  public provinciaList: Provincia[];
  newFileDescripcion: string = "";
  selectedComunidades: Comunidad[] = new Array<Comunidad>();
  filteredComunidadesList: Comunidad[];
  dataEmpleados: DataManager;
  empleadoList: any;
  filteredEmpleadoList: any[];
  // empleadoComunidadSelected: EmpleadoComunidad;
  paisList: Pais[];
  subcontratista: any;
  
  tenantFeatureFlags: TenantFeatureFlags;
  
  constructor(
    private formBuilder: FormBuilder,
    private location: Location,
    public dialog: MatDialog,
    private sharedFunctions: SharedFunctions,
    private route: ActivatedRoute,
    private router: Router,
    private datePipe: DatePipe,
    public tipoDocumentoService: TipoDocumentoService,
    private empleadoService: EmpleadoService,
    private menuService: MenuFuncionService,
    public usuarioService: UsuarioService,
    private provinciaService: ProvinciaService,
    private gremioService: GremioService,
    private comunidadService: ComunidadService,
    private personaService: PersonaService,
    private estadoCivilService: EstadoCivilService,
    private paisService: PaisService,
    private tenantService: TenantService,
  ) {
  }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenuPadre(MenuFuncionCodes.EMPLEADO).subscribe(data => {
      if (data != null && data.Success && data?.Result) {
        this.isValidating = false;
        this.tenantService.getTenantFeatureFlagsById(this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId)).subscribe(dataTenant => {
          if (dataTenant != null && dataTenant.Success) {
            this.tenantFeatureFlags = dataTenant.Result;

            this.canEdit = data.Result.some(x => x == MenuFuncionCodes.EMPLEADO_EDIT);
            this.canAdd = data.Result.some(x => x == MenuFuncionCodes.EMPLEADO_ADD);
            this.canView = data.Result.some(x => x == MenuFuncionCodes.EMPLEADO_LIST);
            this.canDelete = data.Result.some(x => x == MenuFuncionCodes.EMPLEADO_DELETE);
            
            this.loadView();
          }
        },
        (err: HttpErrorResponse) => {
          this.isSearching = false;
          this.sharedFunctions.handleError(err);
        })
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.onCancel();
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    this.pageSizes = GridPageSettings.PageSizeList;
    this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };

    this.buildEmpleadoForm();

    if (this.canAdd || this.canEdit) {
      this.getPaises();
      this.getTiposDocumento();
      this.getProvincias();
      this.getEstadoCivil();
      this.getGremio();
      this.getComunidad();

      // if (this.tenantFeatureFlags?.HabilitarLiquidacionSueldos) {
        this.getEmpleados();
      // }
    }
    
    this.loadEntity();

    this.menuService.checkMenuPadre(MenuFuncionCodes.PERSONA).subscribe(data => {
      if (data != null && data.Success) {
        this.canViewPersonDetail = data.Result != null && data.Result.length > 0;
      }
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });
  }

  buildEmpleadoForm() {
    this.formGroup = this.formBuilder.group({
      'Legajo': [null, [Validators.required]],
      'FechaIngreso': [null, [Validators.required]],
      'FechaEgreso': [null],

      'ApellidoConviviente': [null],
      'NombreConviviente': [null],
      'DniConviviente': [null],
      'CantHijosACargo': [null],

      'Titulo': [null, [Validators.required]],
      'Posicion': [null, [Validators.required]],
      'GremioId': [null],
      'Subcontratista': [null],
      'RemuneracionNeta': [null, [Validators.required]],
      'RemuneracionExtra': [null, [Validators.required]],
      'Aguinaldo': [null, [Validators.required]],

      'Nombre': [null, [Validators.required, Validators.maxLength(150)]],
      'Apellido': [null, [Validators.required, Validators.maxLength(150)]],
      'TipoDocumentoId': [null, Validators.required],
      'NroDocumento': [null, [Validators.required, Validators.maxLength(100)]],
      'Cuit': [null, [Validators.required, Validators.maxLength(100)]],
      'FechaNacimiento': [null, [Validators.required]],

      'MovilContacto': [null, [Validators.required, Validators.maxLength(100)]],
      'MovilContactoOtro': [null],
      'MailContacto': [null, [Validators.maxLength(255), Validators.email]],
      'DomicilioDni': [null, [Validators.required, Validators.maxLength(150)]],
      'CodigoPostalDni': [null, [Validators.required, Validators.maxLength(50)]],
      'DomicilioReal': [null, [Validators.required, Validators.maxLength(150)]],
      'CodigoPostalReal': [null, [Validators.required, Validators.maxLength(50)]],
      'PaisId': [null, [Validators.required]],

      'ProvinciaId': [null, [Validators.required]],
      'LocalidadBarrio': [null, [Validators.required]],
      'ProvinciaRealId': [null, [Validators.required]],
      'LocalidadBarrioReal': [null, [Validators.required, Validators.maxLength(100)]],
      'EstadoCivilId': [null, Validators.required],
      'Activo': [true, Validators.required]
    });

    this.comunidadForm = this.formBuilder.group({
      'Comunidad': [null, Validators.required], 
      'ComunidadId': [null],
      'ComunidadNombre': [null],
      'FechaInicio': [null, Validators.required],
      'FechaFin': [null], 
      'index': [null],
      'Id': [0]
    })
  }

  setQueryParams() {
    if (this.query == null)
        this.query = new Query();

    var index = this.query.params.findIndex(obj => obj.key === "SubcontratistaId");
    if (index >= 0){
      if(this.formGroup?.value?.Subcontratista != null){
        this.query.params[index].value = this.formGroup?.value?.Subcontratista?.Id?.toString();
      }else{
        this.query.params[index].value = this.subcontratista.Id.toString();
      }
    }
    else{
      if(this.formGroup?.value?.Subcontratista != null){
        this.query.addParams("SubcontratistaId", this.formGroup?.value?.Subcontratista?.Id?.toString());
      }else{
        this.query.addParams("SubcontratistaId", this.subcontratista.Id.toString());
      }
    }
  }

  getPaises() {
    var r = new SearchPaisRequest(null, null, true, "Nombre", null, null, true);
    this.isPaisSearching = true;

    this.paisService.search(r).subscribe(data => {
      this.isPaisSearching = false;
      if (data != null) {
        this.paisList = data?.result;
      }
    },
    (err: HttpErrorResponse) => {
      this.isPaisSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getTiposDocumento() {
    var r = new SearchTipoDocumentoRequest(null, null, true, "Nombre", null, null, true);
    this.isTipoDocumentoSearching = true;

    this.tipoDocumentoService.search(r).subscribe(data => {
      this.isTipoDocumentoSearching = false;
      if (data != null) {
        this.tipoDocumentoList = data?.result;
      }
    },
    (err: HttpErrorResponse) => {
      this.isTipoDocumentoSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getProvincias() {
    this.isProvinciaSearching = true;
    var r = new SearchProvinciaRequest(null, null, true, "Nombre", null, null,null,true);
    this.provinciaService.search(r).subscribe(data => {
      this.isProvinciaSearching = false;
      if (data != null) {
        this.provinciaList = data?.result;
      }
    },
    (err: HttpErrorResponse) => {
      this.isProvinciaSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getEstadoCivil() {
    this.isEstadoCivilSearching = true;
    var r = new SearchEstadoCivilRequest(null, null, true, "Nombre", null, null,true);
    this.estadoCivilService.search(r).subscribe(data => {
      this.isEstadoCivilSearching = false;
      this.estadoCivilList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isEstadoCivilSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getGremio() {
    this.isGremioSearching = true;
    var r = new SearchGremioRequest(null, null, true, "Nombre", null, null,true);
    this.gremioService.search(r).subscribe(data => {
      this.isGremioSearching = false;
      this.gremioList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isGremioSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getComunidad() {
    this.isComunidadSearching = true;
    var r = new SearchComunidadRequest(null, null, true, "Nombre", null, null, null, null, null, true);
    this.comunidadService.search(r).subscribe(data => {
      this.isComunidadSearching = false;
      if (data != null) {
        this.comunidadList = data?.result;
        this.filteredComunidadesList = this.comunidadList;
      }
    },
    (err: HttpErrorResponse) => {
      this.isComunidadSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  comprobarEmpleados() {
    this.formGroup?.get("Subcontratista")?.setErrors(null);
    if(this.formGroup?.value?.Subcontratista?.Id == this.empleado?.Id){
      this.formGroup?.get("Subcontratista")?.setErrors({ 'invalid': true });
      return false;
    }
    this.isSubContratistaSearching = true;
    this.setQueryParams();
    this.dataEmpleados = new DataManager({
      url: this.empleadoService.getSearchUrl(),
      adaptor: new WebApiAdaptor(),
      headers: [this.empleadoService.getAuthorizationHeader(),this.empleadoService.getTenantHeader()]
    });
    this.dataEmpleados.executeQuery(this.query).then((result: any) => {this.isSubContratistaSearching = false; this.empleadoList = result.result.result});
  }

  getSubcontratista(subContratistaId: number) {
    this.empleadoService.get(subContratistaId).subscribe(data => {
      this.isSubContratistaSearching = false;
      if (data?.Result != null) {      
        if(this.canEdit){
          this.formGroup.get("Subcontratista")?.setValue(data.Result);
          this.comprobarEmpleados();
        }else{
          this.subcontratista = data.Result;
          this.comprobarEmpleados();
        }
      }
    },
    (err: HttpErrorResponse) => {
      this.isSubContratistaSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getEmpleados() {
    this.formGroup.get("Subcontratista")?.valueChanges
      .pipe(
      filter(res => {
          return res && res !== null && res.length >= 3
      }),
      distinctUntilChanged(),
      debounceTime(1000),
      tap(() => {
          this.filteredEmpleadoList = [];
          this.isSubcontratistaSearching = true;
      }),
      switchMap(value => this.empleadoService.search(new SearchEmpleadoRequestDto(50, null, true, "Nombre", null, null, null, (!isNumber(parseInt(value)) ? value : null), null, null, null, null, (isNumber(parseInt(value)) ? value : null), null, null, null, true))
          .pipe(
          finalize(() => {
              this.isSubcontratistaSearching = false;
          }),
          )
      )
      )
      .subscribe((data: any) => {
        if (data != null && data.result != null)
          this.filteredEmpleadoList = data.result;
        else
          this.filteredEmpleadoList = [];
      });
  }

  displaySubContratista(empleado: EmpleadoDto): string {
    return empleado && empleado?.Nombre || empleado?.Apellido ? (empleado.Apellido + ", " + empleado.Nombre).toUpperCase() + " - " + empleado.Cuit : '';
  }

  isProcessing() {
    return (this.isSearching || this.isEmpleadoSaving);
  }

  loadEntity() {
    this.route.params.subscribe(params => {
      if (params['id'] != null && params['id'] != '0') {
        this.empleadoId = Number(params['id']);

        if (this.empleadoId > 0) {
          this.getDatosEmpleado();
        }
        else
          this.msgError = "Item no válido.";
      }
      else {
        if (this.canAdd) {
          this.empleado = new EmpleadoDto(0,null,null,null,null,null,null,null,null,null,null,null,null,null,null, null, null,null,null,null,null,null,null,null,
            null,0,null,null,null,null,null,null,null,null,null,null,null,null,null,[],[],false,true, null, null, null);
            this.formGroup.patchValue(this.empleado);
        }
        else {
          this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
          this.onCancel(); 
        }
      }
    });
  }

  loadAttachments(id) {
    this.isAttachmentSearching = true;
    this.empleadoService.getAttachments(id).subscribe(data => {
      this.isAttachmentSearching = false;
      this.empleado.Documentos = data.Result;
    },
    (err: HttpErrorResponse) => {
      this.isAttachmentSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  getDatosEmpleado() {
    this.empleadoService.get(this.empleadoId).subscribe(data => {
      this.isSearching = false;
      if (data != null && data.Success) {
        this.empleado = data.Result;

        if (this.empleado != null && this.empleado.Id > 0) {
          this.empleado.PersonaId = data.Result.PersonaId;
          if (this.canEdit) {
            this.formGroup.patchValue(this.empleado);

            if (this.empleado.FechaNacimiento != null)
              this.formGroup.get("FechaNacimiento")?.setValue(this.datePipe.transform(this.empleado.FechaNacimiento, "yyyy-MM-dd"));
            if (this.empleado.FechaIngreso != null)
              this.formGroup.get("FechaIngreso")?.setValue(this.datePipe.transform(this.empleado.FechaIngreso, "yyyy-MM-dd"));
            if (this.empleado.FechaEgreso != null)
              this.formGroup.get("FechaEgreso")?.setValue(this.datePipe.transform(this.empleado.FechaEgreso, "yyyy-MM-dd"));

            this.onTipoDocumentoSelection();
          }

          this.loadAttachments(this.empleado.Id);
          if (this.empleado.SubcontratistaId != null && this.empleado?.SubcontratistaId > 0)
            this.getSubcontratista(this.empleado.SubcontratistaId);
        }
        else
          this.msgError = "No se encontró el empleado seleccionado.";
      }
      else
        this.msgError = "Ocurrió un error al intentar obtener los datos del empleado.";
    },
    (err: HttpErrorResponse) => {
      this.isSearching = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  clearDate(formFieldName: string) {
    if (formFieldName != null && formFieldName.length > 0) {
      if (this.formGroup.get(formFieldName) != null && this.formGroup.get(formFieldName)?.value)
        this.formGroup.get(formFieldName)?.setValue(null);
    }
  }

  clearComunidadDate(formFieldName: string) {
    if (formFieldName != null && formFieldName.length > 0) {
      if (this.comunidadForm.get(formFieldName) != null && this.comunidadForm.get(formFieldName)?.value)
        this.comunidadForm.get(formFieldName)?.setValue(null);
    }
  }

  convertFileToBase64(event, fieldName) {
    const file = event.target.files[0];

    if (file != null) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        // this.backofficeImageBase64 = reader.result;
      };
      reader.onloadend = () => {

        var imageBase64 = reader.result;
        var imageExtension = (file?.name?.split('.')?.pop() ?? "");

        switch (fieldName) {
          case "DniFrente":
          case "DniDorso":
          case "Selfie":
            this.cargarImagenVerificacion(fieldName, imageBase64, imageExtension);
            break;
        }
        // console.log(reader.result);
      };
    }
  }

  hasPersonaFotoDniFrente() {
    return (this.empleado?.FotoDniFrenteUrl != null && this.empleado?.FotoDniFrenteUrl.length > 0);
  }

  hasPersonaFotoDniDorso() {
    return (this.empleado?.FotoDniDorsoUrl != null && this.empleado?.FotoDniDorsoUrl.length > 0);
  }

  hasPersonaFotoSelfie() {
    return (this.empleado?.FotoSelfieUrl != null && this.empleado?.FotoSelfieUrl.length > 0);
  }

  onPersonSearchClick() {
    if (this.isProcessing())
      return;

    const dialogRef = this.dialog.open(DialogPersonaSearchComponent, {
        width: '90%',
        data: new DialogPersonaSearchComponentRequestDto(false, 0)
    });

    dialogRef.afterClosed().subscribe((result: DialogPersonaSearchComponentResponseDto) => {
      if (result != null && !result.Cancelled) {
        var u = (result.Items != null && result.Items.length > 0 ? result.Items[0] : null);
        if (u != null)
          this.mapFromPersona(u);
        this.formGroup.patchValue(this.empleado);
      }
    });
  }

  mapFromPersona(u: Persona) {
    if (this.empleado != null) {
      this.empleado.PersonaId = u?.Id;
      this.empleado.Nombre = u?.Nombre;
      this.empleado.Apellido = u?.Apellido;
      this.empleado.NroDocumento = u?.NroDocumento;
      this.empleado.TipoDocumentoId = u?.TipoDocumentoId;
      this.empleado.FechaNacimiento = u?.FechaNacimiento;
      this.empleado.Cuit = u?.Cuit;
      this.empleado.MailContacto = u?.MailContacto;
      this.empleado.MovilContacto = u?.MovilContacto;
      this.empleado.FotoDniDorsoUrl = u?.FotoDniDorsoUrl;
      this.empleado.FotoDniFrenteUrl = u?.FotoDniFrenteUrl;
      this.empleado.FotoSelfieUrl = u?.FotoSelfieUrl;
    }
  }

  onPersonDeassociateClick() {
    this.mapFromPersona(new Persona(0, null, null, null, null, null, null, null, null,null, true, null, null, null));
    if (this.canEdit)
      this.formGroup.patchValue(this.empleado);
  }

  canDeassociatePerson() {
    return this.canEdit && this.empleado != null && this.empleado.PersonaId > 0;
  }

  //#region FORM ERRORS <SECCION DATOS EMPLEADO>
  getErrorNombre() {
    var v = this.formGroup.get('Nombre');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 150 caracteres alcanzado';
    return '';
  }

  getErrorApellido() {
    var v = this.formGroup.get('Apellido');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 150 caracteres alcanzado';
    return '';
  }

  getErrorFecha() {
    return this.formGroup.get('FechaNacimiento')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorEstadoCivilId() {
    var v = this.formGroup.get('EstadoCivilId');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    return '';
  }

  getErrorLegajo() {
    var v = this.formGroup.get('Legajo');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErroMailContacto() {
    var v = this.formGroup.get('MailContacto');
    if (v?.hasError('maxlength'))
      return 'Límite de 255 caracteres alcanzado';
    if (v?.hasError('email'))
      return 'Debe ingresar un email con formato válido';
    return '';
  }

  getErrorMovilContacto() {
    var v = this.formGroup.get('MovilContacto');
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    else if(v?.hasError('required'))
      return 'El campo es obligatorio';
    return '';
  }

  getErroMovilContactoOtrol() {
    var v = this.formGroup.get('MovilContactoOtro');
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorProvincia() {
    var v = this.formGroup.get('ProvinciaId');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    return '';
  }

  getErrorProvinciaReal(){
    var v = this.formGroup.get('ProvinciaRealId');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    return '';
  }

  getErrorDescripcion() {
    if (this.descripcion.length <= 0 && this.isDescripcionTouched ){
      this.hayErrorDescripcion=true;
      return 'El campo es obligatorio';
    }
    if (this.descripcion.length > 150){      
      this.hayErrorDescripcion=true;
      return 'Límite de 150 caracteres alcanzado';
    }
    return '';
  }

  getErrorTipoDocumentoId() {
    return this.formGroup.get('TipoDocumentoId')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorNroDocumento() {
    var v = this.formGroup.get('NroDocumento');
    if(v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  //#endregion

  //#region FORM ERRORS <SECCION DOMICILIO>
  getErrorDomicilioDni() {
    var v = this.formGroup.get('DomicilioDni');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 150 caracteres alcanzado';
    return '';
  }

  getErrorCodigoPostalDni() {
    var v = this.formGroup.get('CodigoPostalDni');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 50 caracteres alcanzado';
    return '';
  }

  getErrorLocalidadBarrio() {
    var v = this.formGroup.get('LocalidadBarrio');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorDomicilioReal() {
    var v = this.formGroup.get('DomicilioReal');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 150 caracteres alcanzado';
    return '';
  }

  getErrorCodigoPostalReal() {
    var v = this.formGroup.get('CodigoPostalReal');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 50 caracteres alcanzado';
    return '';
  }

  getErrorLocalidadReal() {
    var v = this.formGroup.get('LocalidadBarrioReal');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }
  //#endregion

  getErrorCuit() {
    var v = this.formGroup.get('Cuit');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorSubcontratista(){
    return this.formGroup.get('Subcontratista')?.hasError('invalid') ? 'No se puede seleccionar como Subcontratista a sí mismo.' : '';
  }

  onSaveEmpleado() {
    //Si selecciono como tipo de doc CUIT o CIUL, le asigno el valor del campo Nro. Doc. a CUIT
    if (!this.showCuit) {
      this.formGroup.get("Cuit")?.setValue(this.formGroup.get("NroDocumento")?.value);
    }

    if (!this.formGroup.valid) {
      this.sharedFunctions.showMessage("Por favor complete todos los datos obligatorios para continuar", "Error");

      const controls = this.formGroup.controls;
      Object.keys(controls).forEach(controlName => controls[controlName].markAsTouched());
      return false;
    }

    if (!this.empleado.Activo && this.formGroup.get('FechaEgreso')?.value == null) {
      this.sharedFunctions.showMessage("Si desea inactivar al empleado debe ingresar una fecha de egreso válida", "Error");
      return false;
    }

    var r = new SaveEmpleadoDto(0, null, null, null, null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null, null, null,null,
      null,null,null,null,null,null,null,null,null,null,null,[],null, true);

    r =
    {
      ...this.formGroup.value,
      ...
      {
        Id: (this.empleado?.Id ?? 0),
        Activo: (this.empleado?.Activo ?? true),
        Aguinaldo: this.empleado.Aguinaldo,
        PersonaId: this.empleado.PersonaId ?? 0,
        Documentos: this.empleado?.Documentos,
        Comunidades: this.empleado?.Comunidades?.map(x => new SaveEmpleadoComunidad(x.Id, x.ComunidadId, x.EmpleadoId, x.FechaInicio, x.FechaFin)),
        SubcontratistaId: this.formGroup.value?.Subcontratista?.Id > 0 ? this.formGroup.value?.Subcontratista?.Id : null,
      }
    };

    this.isEmpleadoSaving = true;
    this.empleadoService.save(r).subscribe(data => {
      this.isEmpleadoSaving = false;
      if (data != null && data.Success && data.Result != null && data.Result.Id > 0) {
        this.sharedFunctions.showMessage("Se guardaron correctamente los datos!", "Operación Exitosa!");
          this.onCancel();
      }
      else {
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
      }
    },
    (err: HttpErrorResponse) => {
      this.isEmpleadoSaving = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  //#region COMUNIDADES
  onSaveObra() {
    if (!this.comunidadForm.valid) {
      this.sharedFunctions.showMessage("Complete los campos obligatorios!", "Error");
      const formGroupcontrols = this.comunidadForm.controls;
      Object.keys(formGroupcontrols).forEach(controlName => formGroupcontrols[controlName].markAsTouched());
      return false;
    }

    if (this.empleado.Comunidades == null)
      this.empleado.Comunidades = [];

    this.comunidadForm.get("Id")?.setValue(this.comunidadForm.get("Id")?.value ?? 0);
    this.comunidadForm.get("ComunidadId")?.setValue(this.comunidadForm.get("Comunidad")?.value?.Id);
    this.comunidadForm.get("ComunidadNombre")?.setValue(this.comunidadForm.get("Comunidad")?.value?.Nombre);

    var index = this.comunidadForm.get("index")?.value;
    if (index != null && index >= 0)
      this.empleado.Comunidades[index] = this.comunidadForm.getRawValue();
    else
      this.empleado.Comunidades.push(this.comunidadForm.getRawValue());

    this.comunidadGrid.refresh();
    this.comunidadForm.reset();
  }

  onComunidadDelete(item: any) {
    if (this.empleado.Comunidades != null && this.empleado.Comunidades.length > 0) {
      var index = this.empleado.Comunidades.findIndex(f => f.Id == item.Id);

      if (index >= 0) {
        this.empleado.Comunidades.splice(index, 1);
        this.comunidadGrid.refresh();
      }
    }
  }

  onComunidadEdit(item: any) {
    if (item == null) {
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }

    this.comunidadForm.patchValue(item);

    var c = this.comunidadList.filter(f => f.Id == item.ComunidadId);
    if (c != null && c.length > 0)
      this.comunidadForm.get("Comunidad")?.setValue(c[0]);
  }

  getErrorComunidad() {
    return this.comunidadForm.get("ComunidadId")?.hasError('required') ? 'El campo es obligatorio.' : '';
  }

  getErrorFechaInicio() {
    return this.comunidadForm.get("FechaInicio")?.hasError('required') ? 'El campo es obligatorio.' : '';
  }
  //#endregion

  onCancel() {
    this.location.back();
  }

  onFileAttachedDelete(item: any) {
    if (item.Id > 0)
      this.onExistingFileAttachedDelete(item);
    else
      this.onNewFileAttachedDelete(item);
  }

  onExistingFileAttachedDelete(item: any) {
    if (this.empleado.Documentos != null && this.empleado.Documentos.length > 0) {
      var index = this.empleado.Documentos.findIndex(f => f.Id == item.Id);

      if (index >= 0)
        this.empleado.Documentos.splice(index, 1);
    }
  }

  onNewFileAttachedDelete(item: any) {
    if (this.empleado.Documentos != null && this.empleado.Documentos.length > 0) {
      var index = this.empleado.Documentos.findIndex(f => f.NombreDocumento == item.NombreDocumento);

      if (index >= 0)
        this.empleado.Documentos.splice(index, 1);
    }
  }

  onNewFileAttach(event: any) {
    if (event?.target?.files != null && event.target.files.length > 0) {
      var fileList = event.target.files;

      if (this.empleado.Documentos == null)
        this.empleado.Documentos = [];

      for (var i=0; i<fileList.length; i++) {
        if (this.empleado.Documentos.find(f => f.NombreDocumento == fileList[i].name)) {
          setTimeout(() => {
            this.sharedFunctions.showMessage("Ya existe un archivo con ese nombre. Por favor modifique el nombre del archivo o elimine el ya adjuntado", "Error");
          }, 100);
          return false;
        }
      }

      if (fileList != null && fileList.length > 0) {
        this.isFileAttaching = true;
        this.empleadoService.uploadAttachTemp(fileList).subscribe(data => {
          this.isFileAttaching = false;
          if (data != null && data.Success && data.Result != null && data.Result.Archivos != null && data.Result.Archivos.length > 0) {
            for (let i=0; i<data.Result.Archivos.length; i++) {
              if (data.Result.Archivos[i] != null) {
                data.Result.Archivos[i].Descripcion = this.newFileDescripcion;
                this.empleado.Documentos.push(data.Result.Archivos[i]);
                this.newFileDescripcion = "";
              }
            }
          }
          else
            this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error intentando subir los archivos", "Error");
        },
        (err: HttpErrorResponse) => {
          this.isFileAttaching = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
    }
  }

  cargarImagenVerificacion(fieldName, imageBase64, imageExtension) {
    if (fieldName != null && fieldName.length > 0 && imageBase64 != null && imageBase64.length > 0 && imageExtension != null && imageExtension.length > 0) {

      var index = imageBase64?.toString()?.indexOf(",");
      imageBase64 = (index != null && index >= 0 ? imageBase64?.toString()?.substring(index + 1) : null);

      var r = new SavePersonVerificationImageRequestDto(this.empleado?.PersonaId, fieldName, imageBase64, imageExtension);
      this.isImageLoading = true;

      this.personaService.saveVerificationImagen(r).subscribe(data => {
        this.isImageLoading = false;
        if (data != null && data.Success && data.Result != null) {
          switch (fieldName) {
            case "DniFrente":
              this.empleado.FotoDniFrenteUrl = data.Result;
              break;
            case "DniDorso":
              this.empleado.FotoDniDorsoUrl = data.Result;
              break;
            case "Selfie":
              this.empleado.FotoSelfieUrl = data.Result;
              break;
          }

          this.sharedFunctions.showMessage("Se cargó la imagen exitosamente!", "Imagen cargada");
        }
        else
          this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
      },
      (err: HttpErrorResponse) => {
        this.isImageLoading = false;
        this.sharedFunctions.handleError(err, true);
      })
    }
  }

  onTipoDocumentoSelection() {

    var tipoDoc: TipoDocumento | null = null;
    if (this.tipoDocumentoList != null && this.tipoDocumentoList.length > 0)
      tipoDoc = (this.tipoDocumentoList.filter(f => f.Id == this.formGroup?.get("TipoDocumentoId")?.value))[0];

    this.showCuit = !(tipoDoc?.Nombre?.toUpperCase() == "CUIT" || tipoDoc?.Nombre?.toUpperCase() == "CUIL");
    this.checkPersonaExistance(true, false);
  }

  onNroDocumentoChange() {
    this.checkPersonaExistance(true, false);
  }

  onCuitChange() {
    this.checkPersonaExistance(false, true);
  }

  checkPersonaExistance(searchByDoc: boolean, searchByCuit: boolean) {
    var tipoDocId = this.formGroup?.get("TipoDocumentoId")?.value;
    var nroDoc = this.formGroup?.get("NroDocumento")?.value;
    var cuit = this.formGroup?.get("Cuit")?.value;

    if ((tipoDocId > 0 && nroDoc?.length > 0) || cuit?.length > 0) {
      var r = new SearchPersonaRequestDto(null, null, true, "Apellido", null, null, tipoDocId, nroDoc, null, null, null, true, false);
      if (searchByCuit)
        r = new SearchPersonaRequestDto(null, null, true, "Apellido", null, null, null, null, cuit, null, null, true, false);
      
      this.isPersonaDataSearching = true;

      this.personaService.search(r).subscribe(data => {
        this.isPersonaDataSearching = false;
        if (data != null && data.result != null && data.result.length > 0) {
          this.personaSearchResult = data?.result[0];

          if (this.personaSearchResult?.Id == this.empleado?.PersonaId) {
            this.personaSearchResult = null;
            return;
          }

          var msg = "Se encontró a la persona " + this.personaSearchResult?.Nombre + " " + this.personaSearchResult?.Apellido;
          if (searchByDoc) msg +=" en base al tipo y nro. de documento ingresado. ";
          if (searchByCuit) msg +=" en base al CUIT/CUIL ingresado. ";
          msg += "\n\n¿Desea cargar los datos encontrados?"

          const dialogRef = this.dialog.open(DialogConfirmComponent, {
            data: new DialogConfirmRequest("Persona encontrada", msg, "Sí, carga los datos", "No cargues nada")
          });

          dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
            if (result != null && result.Accepted)
              this.cargarPersonaEncontrada();
            else
              this.noCargarPersonaEncontrada();
          });
        }
      },
      (err: HttpErrorResponse) => {
        this.isPersonaDataSearching = false;
        this.sharedFunctions.handleError(err);
      });
    }
  }

  cargarPersonaEncontrada() {
    if (this.personaSearchResult != null && this.personaSearchResult.Id > 0) {
      if (this.empleado != null)
        this.empleado.PersonaId =this.personaSearchResult.Id;
      this.mapFromPersona(this.personaSearchResult);
      
      if (this.canEdit)
        this.formGroup.patchValue(this.empleado);

      this.personaSearchResult = null;
    }
  }

  noCargarPersonaEncontrada() {
    this.personaSearchResult = null;
  }

  onDelete() {
    if (!this.canDelete) 
        return false;
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: new DialogConfirmRequest(null, "¿Está seguro que desea eliminar el item?", null, null)
    });
    dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
        if (result != null && result.Accepted) {
            this.isDeleting = true;
            this.empleadoService.delete(this.empleado.Id).subscribe(data => {
                this.isDeleting = false;
                if (data != null && data.Success && data.Result) {
                    this.sharedFunctions.showMessage("Se eliminaron correctamente los datos!", "Operación Exitosa!");
                    this.onCancel();
                }
                else
                    this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
            },
            (err: HttpErrorResponse) => {
                this.isDeleting = false;
                this.sharedFunctions.handleError(err, true);
            })
        }
    });
  }

  viewPersona(id: number) {
    if (id == null || id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }

    if (!this.canViewPersonDetail)
      return false;

    this.router.navigate(['persona-edit', id]);
  }
}
